import { FC } from 'react';


interface IProps {
}

const Terms: FC<IProps> = () => {
    return (
        <div>
            <h2>Termos de uso</h2>
            <div>
                <h3>Considerando que:</h3>
                <p>
                    (i) A ZIGNET SOLUÇÕES DE PAGAMENTOS LTDA, inscrita no CNPJ sob
                    nº 06.540.857/0001-80 (“ZIGNET”), nos termos da Portaria do
                    DENATRAN nº 186 de 25 de julho de 2018, é credenciada à exercer
                    a condição de facilitadora, de acordo com o artigo 25-A, §4º da
                    Resolução do CONATRAN nº 619 de 06 de setembro de 2016, de forma
                    a atuar junto aos órgãos e entidades integrantes do Sistema
                    Nacional de Trânsito, viabilizando o pagamento de multas de
                    trânsito e demais débitos relativos ao veículo, com cartões de
                    débito ou crédito, de forma parcelada ou à vista.
                </p>
                <p>
                    (ii) Em vista de seu credenciamento, a ZIGNET disponibiliza para
                    os consumidores interessados (“Usuários”) nos serviços de
                    pagamento dos débitos junto aos órgãos integrantes do Sistema
                    Nacional de Trânsito (“Serviços”), um portal digital que pode
                    ser acessado por meio da URL www.zignet.com.br (“Portal
                    Digital”), por meio do qual o usuário possui acesso a todas as
                    informações necessárias, bem como ao efetivo parcelamento dos
                    débitos.
                </p>
                <p>
                    A ZIGNET disponibiliza o presente Termo de Uso e Outras Avenças
                    (“Termo”), que constituirá, para todos os efeitos, um contrato
                    celebrado entre a ZIGNET e qualquer pessoa que atenda todos os
                    requisitos do presente Termo e deseje contratar os Serviços, o
                    qual deverá ser lido integralmente, antes de sua aceitação.
                </p>
            </div>
            <div>
                <h3>Aceitação do Termo de Uso</h3>
                <p>
                    1.1. O presente Termo contém condições de contratação e uso do
                    Portal Digital para o acesso aos Serviços prestados pela ZIGNET.
                </p>
                <p>
                    1.2. A ZIGNET, na qualidade de facilitadora, fornece ao Usuário,
                    sujeito aos Termos de Uso abaixo, acesso ao Portal Digital para
                    contratação de seus Serviços.
                </p>
                <p>
                    1.3. As informações contidas no Portal Digital poderão ser
                    alteradas, modificadas, ajustadas ou extintas a qualquer
                    momento, sem que haja a necessidade de informação prévia ao
                    Usuário, sendo que essas alterações, modificações e/ou ajustes
                    terão efeito somente após se tornarem públicos.
                </p>
                <p>
                    1.4. Ao realizar a contratação dos Serviços, o USUÁRIO declara
                    que leu e concordou expressamente com a versão mais recente do
                    Termo de Uso, fato este que o vinculará automaticamente às
                    regras aqui contidas.
                </p>
            </div>
            <div>
                <h3>Descrição dos Serviços</h3>
                <p>
                    2.1. A ZIGNET, por meio do Portal Digital, disponibiliza o
                    acesso a produtos e serviços para pagamento de débitos perante
                    aos Órgãos integrantes do Sistema de Trânsito Nacional, por meio
                    de cartão de débito ou crédito, de forma parcelada ou à
                    vista(“Transação”).
                </p>
                <p>
                    2.2. Para obter acesso aos Serviços, o Usuário deverá se
                    cadastrar no Portal Digital, por meio do fornecimento correto
                    das informações solicitadas.
                </p>
                <p>
                    2.3. O Usuário fica desde logo informado e concorda que os
                    Serviços estarão disponíveis 24 (vinte e quatro) horas por dia,
                    7(sete) dias por semana, salvo em casos de culpa de terceiros,
                    caso fortuito ou força maior, e manutenções técnicas e/ ou
                    operacionais que exijam o desligamento temporário do sistema ou
                    impossibilitem o acesso.
                </p>
                <p>
                    2.4. Por meio do Portal Digital, o Usuário poderá realizar as
                    seguintes operações: I – Cadastramento e atualização de dados
                    pessoais; II – Contratação de um dos Serviços disponibilizados
                    pela ZIGNET.
                </p>
            </div>
            <div>
                <h3>Cadastro do Usuário</h3>
                <p>
                    3.1. Para a utilização dos Serviços, o Usuário deverá efetuar
                    previamente seu cadastro no Portal Digital, no qual deverá
                    fornecer informações pessoais verdadeiras e atuais, dentre elas,
                    o nome ou razão social, o CPF ou CNPJ, telefone e endereço de e
                    - mail e no caso de pessoas jurídicas, os dados cadastrais de
                    seus sócios ou representantes legais, responsabilizando-se pela
                    veracidade das informações e pela sua atualização, quando
                    necessário.
                </p>
                <p>
                    3.2. Só poderão se cadastrar no Portal Digital pessoas físicas
                    ou jurídicas que tenham capacidade legal para contratar e que
                    sejam residentes no Brasil. Portanto, não poderão se cadastrar e
                    manter-se cadastrados os menores de 18 anos, as pessoas
                    civilmente incapazes, pessoas sem CPF ou sem CNPJ, ou ainda, com
                    CPF ou CNPJ baixado, cancelado, não informado, nulo, suspenso,
                    cujo titular tenha falecido, ou cujo sócio e / ou representante
                    indicado se enquadre em alguma dessas situações ou aqueles
                    Usuários que tenham sido suspensos ou inabilitados no Portal
                    Digital, temporária ou definitivamente.
                </p>
                <p>
                    3.3. As informações pessoais fornecidos pelo Usuário deverão ser
                    completas, com informações exatas, precisas e verdadeiras, sendo
                    o Usuário o único responsável, civil e criminalmente, pelos
                    dados fornecidos, obrigando - se, ainda, a atualizá-los sempre
                    que necessário e/ ou solicitado sob pena(i) de não utilização
                    dos Serviços; (ii)suspensão dos Serviços; e / ou(iii)
                    responsabilização nas esferas cível, administrativa e criminal
                    na forma prevista em Lei.
                </p>
                <p>
                    3.4. Caso seja verificado que as informações fornecidas são
                    falsas ou incompletas, a ZIGNET poderá suspender temporariamente
                    o cadastro do Usuário, interrompendo a utilização dos serviços,
                    até que a situação seja regularizada.
                </p>
                <p>
                    3.5. A ZIGNET disponibiliza para os usuários, antes da
                    contratação dos Serviços, a Política de Privacidade praticada
                    pela empresa, a qual trata especificamente do fornecimento de
                    dados pessoais do Usuário para cadastro e o seu tratamento.
                </p>
                <p>
                    3.6 O Usuário, ao contratar os Serviços, declara, também, que
                    teve acesso integral e aceita os termos da Política de
                    Privacidade da ZIGNET.
                </p>
            </div>
            <div>
                <h3>Condições do Serviço</h3>
                <p>
                    4.1. A ZIGNET atua exclusivamente como empresa facilitadora, de
                    modo a viabilizar o pagamento de débitos pelo Usuário, razão
                    pela qual o parcelamento no cartão de crédito ou o pagamento à
                    vista por meio de cartão de débito é de exclusiva
                    responsabilidade do proprietário do veículo e/ ou responsável
                    pelo cartão utilizado.
                </p>
                <p>
                    4.2. Os custos decorrentes do parcelamento junto à empresa
                    credenciada no DENATRAN não fazem parte dos débitos registrados
                    no cadastro do veículo junto ao órgão, e a responsabilidade pelo
                    pagamento é do Usuário que optar por essa modalidade de
                    pagamento.
                </p>
                <p>
                    4.3. O parcelamento apenas proporciona de imediato a emissão do
                    Certificado de Registro e Licenciamento do Veículo(“CRLV”) e a
                    liberação do veículo, caso não haja mais nenhum impedimento
                    legal ou financeiro.Quaisquer outras medidas necessárias à
                    emissão do CRLV e para a liberação do veículo serão de
                    responsabilidade exclusiva do Usuário, sendo a ZIGNET isenta de
                    qualquer responsabilidade ou obrigação nesse sentido.
                </p>
                <p>
                    4.4. A baixa e a quitação efetiva dos débitos junto ao cadastro
                    do veículo ocorrerão em até 72 (setenta e duas) horas após a
                    confirmação do parcelamento.No caso de IPVA, essa baixa deverá
                    ser feita em até 48(quarenta e oito) horas úteis, podendo variar
                    de acordo com os prazos das instituições financeiras envolvidas.
                </p>
                <p>
                    4.5. Fica esclarecido que a emissão do certificado e a liberação
                    do veículo, após o pagamento dos débitos, são de
                    responsabilidade do Órgão e entidade vinculados ao Sistema
                    Nacional de Trânsito, de modo que qualquer atraso ou recusa na
                    liberação, após a confirmação do pagamento, é de
                    responsabilidade exclusiva de referido Órgão e entidade, de modo
                    que a ZIGNET não possui qualquer responsabilidade nesse sentido.
                </p>
                <p>
                    4.6. Em caso de recurso deferido pela Autoridade competente,
                    após o pagamento do débito, haverá a restituição, por exclusiva
                    responsabilidade do DETRAN, apenas do débito original constante
                    no cadastro do veículo, excluídas taxas administrativas
                    relativas ao pagamento e / ou parcelamento via cartão.
                </p>
                <p>
                    4.7. Todas as taxas de juros envolvidas no parcelamento,
                    inclusive CET, valor total do parcelamento e o valor de cada
                    parcela serão informadas no Portal Digital durante a contratação
                    dos Serviços. O Usuário deverá garantir que entendeu de forma
                    clara as condições oferecidas pela ZIGNET antes da contratação
                    dos Serviços, devendo entrar em contato por meio de um dos
                    canais disponibilizados em caso de dúvidas. 4.8.Ao contratar os
                    Serviços por meio da concretização da Transação de pagamento, o
                    Usuário concorda expressamente com todos os valores e forma de
                    pagamento oferecidos pela ZIGNET
                </p>
                <p>
                    4.9. Em caso de contestação da Transação pela Instituição
                    Financeira, de forma posterior ao parcelamento ou pagamento do
                    débito, sem motivação comprovada, o proprietário do veículo
                    vinculado aos débitos poderá sofrer sanções legais e
                    administrativas, inclusive, mas sem se limitar, bloqueio
                    administrativo junto ao DETRAN, além de indenizar a ZIGNET por
                    eventuais prejuízos sofridos, conforme cláusula 5.1 deste Termo.
                </p>
                <p>
                    4.10. A ZIGNET reserva-se o direito de não processar as
                    Transações que: (i)contenham dados incompletos, contraditórios
                    ou inválidos; (ii)A ZIGNET, a seu exclusivo critério, considere
                    envolver algum risco; (ii)estejam em desacordo ao presente
                    Termo; ou(iv) não sejam autorizadas pelo banco ou pela
                    credenciadora ou pelo emissor de cartões de crédito ou débito.
                </p>
                <p>
                    4.11. A ZIGNET poderá cancelar uma Transação sempre que
                    verificar que a mesma: (i)foi invalidada pelo banco do Usuário;
                    (ii) foi processada incorretamente pela ZIGNET, (iii)o Usuário
                    não tinha autorização para enviá-lo, seja por fraude ou qualquer
                    outro motivo, (iv) decorre de qualquer operação em desacordo com
                    este Termo, ou (v) caso de suspeita de fraude ou qualquer
                    irregularidade.
                </p>
            </div>
            <div>
                <h3>Indenização</h3>
                <p>
                    5.1. O Usuário concorda em indenizar a ZIGNET de qualquer dano
                    que esta venha a sofrer por culpa ou dolo do Usuário na
                    utilização irregular ou ilegal dos Serviços e em razão do
                    descumprimento do presente Termo de Uso e/ ou demais políticas
                    da ZIGNET; ou ainda pela violação de qualquer lei e direito de
                    terceiros, responsabilizando - se por eventuais perdas e danos.
                </p>
                <p>
                    5.2.A ZIGNET não poderá ser responsabilizada por qualquer falha
                    ou não funcionamento dos serviços provenientes de terceiros ou
                    decorrentes de caso fortuito ou força maior. 5.3.Em hipótese
                    alguma a ZIGNET poderá ser responsabilizada por qualquer erro
                    originado na utilização ou não utilização do Serviço.
                </p>
            </div>
            <div>
                <h3>Prazo</h3>
                <p>
                    6.1. O Portal Digital estará disponível para o Usuário por prazo
                    indeterminado, sendo certo que a ZIGNET poderá, à sua livre
                    discrição, encerrar a prestação dos Serviços, independentemente
                    de qualquer tipo de comunicação prévia ao Usuário.
                </p>
                <p>
                    6.2. Em caso de encerramento dos Serviços, a ZIGNET permanecerá
                    responsável por todos os direitos e obrigações decorrentes de
                    Serviços já contratados e não encerrados.
                </p>
            </div>
            <div>
                <h3>Disposições Gerais</h3>
                <p>
                    7.1. A ZIGNET utilizará os dados e informações pessoais dos
                    Usuários para prestar os Serviços, nas formas e casos
                    estabelecidos na Política de Privacidade da ZIGNET.No entanto,
                    além das hipóteses previstas na Política de Privacidade, a
                    ZIGNET poderá coletar e revelar dados cadastrais de seus
                    usuários para terceiros, incluindo, mas sem se limitar a,
                    empresas integrantes do mesmo grupo econômico, parceiros
                    comerciais, instituições financeiras, autoridades e pessoas
                    físicas ou jurídicas(i) que alegarem ter sido lesadas por
                    Usuários; (ii) com a finalidade de realizar estudos internos,
                    (iii) que prestem serviços à ZIGNET e/ ou com parceiros
                    comerciais para fins de negócios da ZIGNET, tais como, mas sem
                    se limitar ao gerenciamento de risco, a detecção de atos
                    ilícitos, o envio anúncios personalizados, a oferta conjunta de
                    produtos ou serviços, a análise de dados estatísticos, dentre
                    outros; (iv)que prestem serviços de valor agregado que se
                    integrem dentro do Portal Digital ou mediante links a outros
                    sites eletrônicos da Internet, para atender necessidades dos
                    Usuários relacionadas aos Serviços; (iv) com o objetivo de
                    propor iniciativas comerciais e promocionais da ZIGNET. Para
                    mais informações, consulte as Políticas de Privacidade da
                    ZIGNET, que passam a fazer parte integrante dos presente Termo.
                </p>
                <p>
                    7.2. O Usuário autoriza de forma irrevogável a ZIGNET ou quem a
                    ZIGNET designe, a gravar todas as operações e / ou telefonemas
                    do Usuário relativos aos serviços prestados pela ZIGNET, e a
                    utilizar essas gravações como meio probatório perante
                    autoridades administrativas ou judiciais. Os registros emitidos
                    pela ZIGNET serão considerados prova suficiente do cumprimento
                    das Transações, substituem a necessidade de qualquer recibo e
                    são plenamente oponíveis ao Usuário.
                </p>
                <p>
                    7.3. A não exigência, por qualquer uma das partes, do
                    cumprimento de qualquer cláusula ou condição estabelecida, será
                    considerada mera tolerância, não implicando na sua novação, e
                    tão pouco na abdicação do direito de exigi - la no futuro, não
                    afetando a validade deste instrumento e quaisquer de suas
                    condições.
                </p>
                <p>
                    7.4. Os regulamentos relativos a eventuais campanhas
                    promocionais, propagandas de incentivo e outros programas que
                    propiciem benefícios adicionais ao Usuário serão divulgados
                    separadamente, sendo que, por mera liberalidade, alguns serviços
                    poderão ser oferecidos gratuitamente ou com variações dos preços
                    e condições regularmente ofertados a título promocional e por
                    prazo determinado.
                </p>
                <p>
                    7.5. Na hipótese de qualquer uma das disposições deste Termo vir
                    a ser considerada contrária à lei brasileira, por qualquer
                    autoridade governamental ou decisão judicial, as demais
                    disposições não afetadas continuarão em vigor e as partes
                    deverão alterar este instrumento de forma a adequá-lo a tal lei
                    ou à decisão judicial.
                </p>
                <p>
                    7.6. Este Termo obriga as partes e seus sucessores a qualquer
                    título
                </p>
                <p>
                    7.7. O Usuário reconhece que poderão ser veiculados anúncios e
                    propagandas de terceiros e que, caso venha a adquirir qualquer
                    produto ou serviço lá anunciado, caberá ao anunciante a
                    responsabilidade por quaisquer produtos ou serviços adquiridos,
                    bem como pelo conteúdo publicado.
                </p>
                <p>
                    7.8. O usuário autoriza a ZIGNET a utilizar recursos, tais como,
                    mas não se limitando, a & quot; cookies & quot; (pequenas
                    mensagens comerciais instantâneas), a fim de oferecer um Serviço
                    melhor e mais personalizado.
                </p>
                <p>
                    7.9. O Usuário declara, ainda, que cumpre e faz cumprir, bem
                    como suas afiliadas, acionistas, conselheiros, diretores,
                    funcionários, agentes e/ ou eventuais subcontratados(“Pessoas
                    Relacionadas”), todas as leis, regras, regulamentos e normas
                    aplicáveis, emitidos por qualquer jurisdição aplicável ao
                    Usuário, que versam sobre atos de corrupção, suborno e atos
                    lesivos contra a administração pública, incluindo, mas não se
                    limitando a Lei nº 12.846 / 13(“Leis Anticorrupção”); na medida
                    em que(i) mantém políticas e procedimentos internos que
                    assegurem integral cumprimento das Leis Anticorrupção; (ii)dá
                    pleno conhecimento das Leis Anticorrupção a todos os
                    profissionais que venham a ser relacionar com o Usuário,
                    conforme aplicável; (iii)abstém - se de praticar quaisquer atos
                    estabelecidos nas Leis Anticorrupção, no seu interesse ou para
                    seu benefício, exclusivo ou não; e(iv) caso tenha conhecimento
                    de qualquer ato ou fato que viole as Leis Anticorrupção,
                    comunicará imediatamente a ZIGNET, que poderá tomar todas as
                    providências que entender necessárias.
                </p>
                <p>
                    7.10. O presente Termo de Uso será interpretado e regido
                    conforme a legislação brasileira e aplicado em todo território
                    nacional.
                </p>
                <p>
                    7.11. Este Termo de Uso rege a relação entre o Usuário e a
                    ZIGNET enquanto ativo o seu cadastro no Portal Digital.
                </p>
            </div>
            <div>
                <h3>Foro</h3>
                <p>
                    8.1. As partes elegem o foro central da Comarca da Cidade de São
                    Paulo, Estado de São Paulo, para dirimir eventuais dúvidas ou
                    controvérsias decorrentes do presente Contrato, excluindo-se
                    qualquer outro, por mais privilegiado que seja.
                </p>
            </div>
        </div>

    )
}

export default Terms;
